import React from "react";
import { Outlet, useLocation } from "react-router-dom";
import back from "../../Assets/Images/back.jpg";
import Nav from "../Shared/Header/Nav";
import Header from "../Shared/Header";
import Footer from "../Shared/Footer";

const Layout = () => {
  const location = useLocation();

  return (
    <main className={`App`}>
      {/* Background Cover */}
      <div
        className="absolute top-0 right-0 bottom-0 left-0 -z-10 opacity-[.15]"
        style={{
          backgroundImage:
            location.pathname === "/home" || location.pathname === "/"
              ? ""
              : `url(${back})`,
          backgroundSize: "cover",
          backgroundRepeat: "no-repeat",
          backgroundPosition: "bottom",
        }}
      ></div>

      <div className="grid h-screen grid-rows-[auto,1fr,auto] grid-cols-[min-content,1fr] gap-3">
        <div className="col-span-2 h-24 ">
          <Header />
        </div>

        <div className="w-full md:w-40 relative">
          <Nav />
        </div>

        <div className="pr-3 overflow-auto">
          <Outlet />
        </div>

        <div className="col-span-2 ">
          <Footer />
        </div>
      </div>
    </main>
  );
};

export default Layout;
